import { render, staticRenderFns } from "./AdminBlocked.vue?vue&type=template&id=d8293542&scoped=true"
import script from "./AdminBlocked.vue?vue&type=script&lang=js"
export * from "./AdminBlocked.vue?vue&type=script&lang=js"
import style0 from "./AdminBlocked.vue?vue&type=style&index=0&id=d8293542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8293542",
  null
  
)

export default component.exports